import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ShipClassService {
  OBPortalSvcURL = '';
  private readonly CACHE_TTL_MS = 60 * 60 * 1000;
  private cache = new Map<number | undefined, { obs: Observable<any>; ts: number }>();

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public getShipClass(shpId: number | undefined): Observable<any> {
    const cached = this.cache.get(shpId);
    if (cached && (Date.now() - cached.ts) < this.CACHE_TTL_MS) {
      return cached.obs;
    }

    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const ShipInfo: JSON = <JSON>(<unknown>{
      shipId: shpId,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const obs = this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetShipClass',
      JSON.stringify(ShipInfo),
      { headers: headers }
    ).pipe(shareReplay(1));

    this.cache.set(shpId, { obs, ts: Date.now() });
    return obs;
  }
}
